import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createSlots as _createSlots } from "vue"

const _hoisted_1 = { class: "flex items-center justify-between section-container background-gray q-py-lg" }
const _hoisted_2 = { class: "page-title" }
const _hoisted_3 = { class: "campaigns-list flex justify-end items-center" }
const _hoisted_4 = { class: "flex row items-center" }
const _hoisted_5 = { class: "col-12" }
const _hoisted_6 = {
  class: "col-12 q-py-lg q-px-md table-mobile-even-bg",
  style: {"border-top":"1px solid var(--border-color)","background":"#FBFBFB"}
}
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-6 flex items-center" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "additional-text q-mr-sm" }, "ID:", -1)
const _hoisted_10 = { class: "col-6 flex items-center" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "additional-text q-mr-sm" }, "Offer:", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "horizontal-line q-my-lg" }, null, -1)
const _hoisted_13 = { class: "row" }
const _hoisted_14 = { class: "col-6 q-mb-lg" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "additional-text q-mr-sm" }, "Date:", -1)
const _hoisted_16 = { class: "col-6 q-mb-lg" }
const _hoisted_17 = { class: "additional-text q-mr-sm" }
const _hoisted_18 = { class: "col-12 q-mb-lg" }
const _hoisted_19 = { class: "col-12 flex justify-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_tab = _resolveComponent("q-tab")!
  const _component_q_tabs = _resolveComponent("q-tabs")!
  const _component_Filters = _resolveComponent("Filters")!
  const _component_CampaignEditDialog = _resolveComponent("CampaignEditDialog")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_q_td = _resolveComponent("q-td")!
  const _component_CampaignUrlsBuilder = _resolveComponent("CampaignUrlsBuilder")!
  const _component_q_table = _resolveComponent("q-table")!
  const _component_q_page = _resolveComponent("q-page")!

  return (_openBlock(), _createBlock(_component_q_page, { class: "q-mb-lg" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('campaigns')), 1),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_q_btn, {
            "no-caps": "",
            class: "q-btn__main-size text-weight-bold",
            label: _ctx.$t('create_new_campaign'),
            color: "primary",
            unelevated: "",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showCampaignEditDialog = !_ctx.showCampaignEditDialog))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_q_icon, {
                name: "add",
                style: {"margin-left":"10px"},
                size: "16px"
              })
            ]),
            _: 1
          }, 8, ["label"])
        ])
      ]),
      _createVNode(_component_q_tabs, {
        modelValue: _ctx.campaignStatusTab,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.campaignStatusTab) = $event)),
        "inline-label": "",
        breakpoint: 0,
        align: "justify",
        class: "bg-white section-container q-pt-lg"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_q_tab, {
            "no-caps": "",
            name: _ctx.campaignStatusOptions[0].value,
            label: _ctx.campaignStatusOptions[0].label
          }, null, 8, ["name", "label"]),
          _createVNode(_component_q_tab, {
            "no-caps": "",
            name: _ctx.campaignStatusOptions[1].value,
            label: _ctx.campaignStatusOptions[1].label
          }, null, 8, ["name", "label"])
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_Filters, {
            onReset: _ctx.resetFilters,
            onChange: _ctx.onChangeFilters,
            onChangeAll: _ctx.changeAll,
            "current-filters": _ctx.filters
          }, null, 8, ["onReset", "onChange", "onChangeAll", "current-filters"])
        ]),
        (_ctx.showCampaignEditDialog)
          ? (_openBlock(), _createBlock(_component_CampaignEditDialog, {
              key: 0,
              open: _ctx.showCampaignEditDialog,
              onClose: _ctx.onCloseDialog,
              onRefresh: _ctx.onRequest,
              campaignId: _ctx.selectedCampaignId
            }, null, 8, ["open", "onClose", "onRefresh", "campaignId"]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", null, [
        _createVNode(_component_q_table, {
          rows: _ctx.rows,
          columns: _ctx.columns,
          "row-key": "id",
          pagination: _ctx.pagination,
          "onUpdate:pagination": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.pagination) = $event)),
          loading: _ctx.loading,
          onRequest: _ctx.onRequest,
          grid: _ctx.$q.screen.width <= 1199,
          flat: "",
          "binary-state-sort": "",
          "rows-per-page-label": _ctx.$t('rows_per_page'),
          style: {"padding-top":"32px"}
        }, _createSlots({
          "body-cell-offerName": _withCtx((props) => [
            _createVNode(_component_q_td, { props: props }, {
              default: _withCtx(() => [
                _createVNode(_component_router_link, {
                  class: "offer-link underlined text-primary text-weight-bold",
                  to: { name: 'offer', params: { id: props.row.offerId } }
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(props.row.offerName), 1)
                  ]),
                  _: 2
                }, 1032, ["to"])
              ]),
              _: 2
            }, 1032, ["props"])
          ]),
          "body-cell-url": _withCtx((props) => [
            _createVNode(_component_q_td, { props: props }, {
              default: _withCtx(() => [
                _createVNode(_component_q_btn, {
                  color: "primary",
                  outline: "",
                  "no-caps": "",
                  class: "q-btn__main-size text-weight-bold",
                  "icon-right": _ctx.heroOutline24Link,
                  label: _ctx.$t('get_link'),
                  onClick: ($event: any) => (
                props.row.showCampaignUrlsBuilder = !props.row
                  .showCampaignUrlsBuilder
              )
                }, null, 8, ["icon-right", "label", "onClick"]),
                (props.row.showCampaignUrlsBuilder)
                  ? (_openBlock(), _createBlock(_component_CampaignUrlsBuilder, {
                      key: 0,
                      open: props.row.showCampaignUrlsBuilder,
                      onClose: ($event: any) => (props.row.showCampaignUrlsBuilder = false),
                      campaignId: props.row.id
                    }, null, 8, ["open", "onClose", "campaignId"]))
                  : _createCommentVNode("", true)
              ]),
              _: 2
            }, 1032, ["props"])
          ]),
          "body-cell-actions": _withCtx((props) => [
            _createVNode(_component_q_td, { props: props }, {
              default: _withCtx(() => [
                _createVNode(_component_q_icon, {
                  class: "cursor-pointer",
                  name: _ctx.heroOutline24ChartBar,
                  onClick: ($event: any) => (_ctx.$router.push('/statistics?campaignId=' + props.row.id)),
                  style: {"margin-right":"12px","color":"var(--table-action-color)"},
                  size: "16px"
                }, null, 8, ["name", "onClick"]),
                _createVNode(_component_q_icon, {
                  class: "cursor-pointer",
                  name: _ctx.heroOutline24PencilSquare,
                  onClick: ($event: any) => (_ctx.openCampaignDialog(props.row.id)),
                  style: {"margin-right":"12px","color":"var(--table-action-color)"},
                  size: "16px"
                }, null, 8, ["name", "onClick"]),
                _createVNode(_component_q_icon, {
                  class: "cursor-pointer",
                  name: _ctx.heroOutline24DocumentDuplicate,
                  onClick: ($event: any) => (_ctx.copyRow(props)),
                  style: {"margin-right":"12px","color":"var(--table-action-color)"},
                  size: "16px"
                }, null, 8, ["name", "onClick"]),
                _createVNode(_component_q_icon, {
                  class: "cursor-pointer",
                  name: _ctx.heroOutline24Trash,
                  onClick: ($event: any) => (_ctx.deleteRow(props)),
                  size: "16px",
                  style: {"color":"var(--table-action-color)"}
                }, null, 8, ["name", "onClick"])
              ]),
              _: 2
            }, 1032, ["props"])
          ]),
          _: 2
        }, [
          (_ctx.$q.screen.width <= 1199)
            ? {
                name: "item",
                fn: _withCtx((props) => [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("div", _hoisted_8, [
                        _hoisted_9,
                        _createTextVNode(" " + _toDisplayString(props.row.id), 1)
                      ]),
                      _createElementVNode("div", _hoisted_10, [
                        _hoisted_11,
                        _createVNode(_component_router_link, {
                          class: "offer-link underlined text-primary text-weight-bold",
                          to: { name: 'offer', params: { id: props.row.offerId } }
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(props.row.offerName), 1)
                          ]),
                          _: 2
                        }, 1032, ["to"])
                      ])
                    ]),
                    _hoisted_12,
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("div", _hoisted_14, [
                        _hoisted_15,
                        _createElementVNode("div", null, _toDisplayString(_ctx.format(props.row.createdAt)), 1)
                      ]),
                      _createElementVNode("div", _hoisted_16, [
                        _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.$t('campaign_name')) + ": ", 1),
                        _createElementVNode("div", null, _toDisplayString(props.row.name), 1)
                      ]),
                      _createElementVNode("div", _hoisted_18, [
                        _createVNode(_component_q_btn, {
                          color: "primary",
                          outline: "",
                          "no-caps": "",
                          class: "q-btn__main-size text-weight-bold full-width",
                          "icon-right": _ctx.heroOutline24Link,
                          label: _ctx.$t('get_link'),
                          onClick: ($event: any) => (
                    props.row.showCampaignUrlsBuilder = !props.row
                      .showCampaignUrlsBuilder
                  )
                        }, null, 8, ["icon-right", "label", "onClick"])
                      ]),
                      _createElementVNode("div", _hoisted_19, [
                        _createVNode(_component_q_icon, {
                          class: "cursor-pointer",
                          name: _ctx.heroOutline24ChartBar,
                          onClick: ($event: any) => (
                    _ctx.$router.push('/statistics?campaignId=' + props.row.id)
                  ),
                          style: {"margin-right":"48px","color":"var(--table-action-color)"},
                          size: "16px"
                        }, null, 8, ["name", "onClick"]),
                        _createVNode(_component_q_icon, {
                          class: "cursor-pointer",
                          name: _ctx.heroOutline24PencilSquare,
                          onClick: ($event: any) => (_ctx.openCampaignDialog(props.row.id)),
                          style: {"margin-right":"48px","color":"var(--table-action-color)"},
                          size: "16px"
                        }, null, 8, ["name", "onClick"]),
                        _createVNode(_component_q_icon, {
                          class: "cursor-pointer",
                          name: _ctx.heroOutline24DocumentDuplicate,
                          onClick: ($event: any) => (_ctx.copyRow(props)),
                          style: {"margin-right":"48px","color":"var(--table-action-color)"},
                          size: "16px"
                        }, null, 8, ["name", "onClick"]),
                        _createVNode(_component_q_icon, {
                          class: "cursor-pointer",
                          name: _ctx.heroOutline24Trash,
                          onClick: ($event: any) => (_ctx.deleteRow(props)),
                          size: "16px",
                          style: {"color":"var(--table-action-color)"}
                        }, null, 8, ["name", "onClick"])
                      ])
                    ])
                  ])
                ]),
                key: "0"
              }
            : undefined
        ]), 1032, ["rows", "columns", "pagination", "loading", "onRequest", "grid", "rows-per-page-label"])
      ])
    ]),
    _: 1
  }))
}